import router from './router'
import store from './store'

// Setelah deploy, chunk lama sudah dihapus dari S3. Tab yang masih memuat
// versi lama akan gagal lazy-load route -> reload penuh ke route tujuan.
// Dibatasi sekali per 10 detik agar tidak terjadi reload loop.
router.onError((error, to) => {
  const isChunkError = /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError/i.test(error && error.message)
  if (!isChunkError) return
  const key = 'chunk-reload-at'
  let last = 0
  try { last = Number(sessionStorage.getItem(key)) || 0 } catch (e) {}
  if (Date.now() - last < 10000) return
  try { sessionStorage.setItem(key, String(Date.now())) } catch (e) {}
  window.location.assign(to && to.fullPath ? to.fullPath : window.location.href)
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters['app/isLoggedin']) {
    next({ name: 'Login' })
  } else {
    next()
  }
})
